
import { mapState } from 'vuex'
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js'
import VueImageLightboxCarousel from '@/components/lightbox/VueImageLightboxCarousel'
import AppCarousel from '@/components/ui/AppCarousel.vue'

export default {
  mdiArrowLeft,
  mdiArrowRight,

  components: {
    VueImageLightboxCarousel,
    AppCarousel
  },

  data: () => {
    return {
      showLightbox: false,
      translatedDamages: []
    }
  },
  async fetch () {
    const storeCode = this.$i18n.locale
    if (storeCode !== 'de') {
      await this.$axios.get(`/public/product/damages/get/${this.product.entityId}?storeCode=${storeCode}`)
        .then((response) => {
          this.translatedDamages = response.data
        })
    }
  },

  computed: {
    ...mapState('product', {
      product (state) {
        return state.data
      }

    }),
    images () {
      return this.product.damages?.map(damage => damage.image) ?? []
    },
    damages () {
      if (this.translatedDamages.length > 0) {
        return this.translatedDamages
      } else {
        return this.product.damages?.filter(damage => damage.image !== null)
      }
    }
  },

  methods: {
    openLightbox (index) {
      this.showLightbox = true

      this.$refs.lightboxCarousel.showImage(index)
    }
  }
}
